import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '../api.conf';
import { DraftAppointmentPayload } from '../../interfaces';
import { PublicAppointmentResponseDTO } from '@paymash/sdk/api';

@Injectable()
export class AppointmentApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  createDraftAppointment(
    companyUuid: string,
    payload: DraftAppointmentPayload
  ): Observable<PublicAppointmentResponseDTO> {
    return this.http.post<PublicAppointmentResponseDTO>(
      `${this.basePath}/companies/${companyUuid}/appointments`,
      payload
    );
  }

  deleteAppointment(companyUuid: string, appointmentUuid: string) {
    return this.http.delete(`${this.basePath}/companies/${companyUuid}/appointments/${appointmentUuid}`);
  }
}
